import { RoleGaurd } from "components/layout/RoleGaurd";
import Btn from "lib/button/Btn";
import React from "react";
import PropTypes from "prop-types";

function ActionButtons({ multiStatusHandler, multiDeleteHandler, module }) {
  return (
    <div className="action-btns mt-0">
      {multiStatusHandler && (
        <RoleGaurd module={module} permission="Change Status">
          <Btn variant="success-light" className="mt-20 me-4" text="Active" onClick={() => multiStatusHandler(true)} />
        </RoleGaurd>
      )}
      {multiStatusHandler && (
        <RoleGaurd module={module} permission="Change Status">
          <Btn
            variant="warning-light"
            className="mt-20 me-4"
            text="Inactive"
            onClick={() => multiStatusHandler(false)}
          />
        </RoleGaurd>
      )}
      {multiDeleteHandler && (
        <RoleGaurd module={module} permission="Delete">
          <Btn variant="danger-light" className="mt-20" text="Delete" onClick={() => multiDeleteHandler()} />
        </RoleGaurd>
      )}
    </div>
  );
}

ActionButtons.propTypes = {
  multiStatusHandler: PropTypes.func,
  multiDeleteHandler: PropTypes.func,
  module: PropTypes.string.isRequired,
};

export default ActionButtons;
